import React from 'react';

import { Card } from '@iris/react-components';

import { useVehicleSpecsData } from '@/containers/vdp/hooks';

import { VehicleFeatureItem } from './components';
import { getColorSwatchData } from './utils';

function VehicleFeatureHighlights() {
    const vehicleSpecsData = useVehicleSpecsData('subbar');

    const availableSpecs = vehicleSpecsData?.filter((details) => !details.specData?.emptyRow);

    const { exteriorColorData, interiorColorData } = getColorSwatchData(availableSpecs);

    return (
        <Card
            variant="subtle"
            className="margin-bottom-5"
        >
            <VehicleFeatureItem
                availableSpecs={availableSpecs}
                exteriorColorData={exteriorColorData}
                interiorColorData={interiorColorData}
            />
        </Card>
    );
}

export default VehicleFeatureHighlights;
